module.exports = __webpack_public_path__ + "img/bg-16.dea4ca67.jpg";